module.exports = __webpack_public_path__ + "img/high-you-icon2.8008a929.png";